export default __webpack_public_path__ + "static/montserrat-v15-latin-italic-7583622cfde30ae49086d18447ab28e7.woff";